<template>
  <div>
    <div class="progress mt-3">
      <div
        :class="`progress-bar progress-bar-striped ${animate}`"
        role="progressbar"
        :style="progressValueStyle"
        :aria-valuenow="$store.getters.progress"
        aria-valuemin="0"
        :aria-valuemax="$store.getters.duration"
      ></div>
    </div>
  </div>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
//import Bus from "../services/bus.js";

export default {
  name: "progress-component",
  mixins: [inputComponentMixin],
  data: function data() {
    return {
      amount: 20
    };
  },
  computed: {
    animate() {
      return this.$store.getters.isPlaying && !this.$store.getters.isFinished
        ? "progress-bar-animated"
        : "";
    },
    progressValueStyle() {
      return `width: ${Math.round(
        (this.$store.getters.progress / this.$store.getters.duration) * 100
      )}%`;
    }
  }
};
</script>
<style scoped>
span {
  margin-top: 2%;
}
</style>
